import React, { FC } from "react";
import { Typography, Button, ScalableImage } from "design_system/src";
import { ReactComponent as COMPANY } from "design_system/src/static/icons/company.svg";
import { ReactComponent as MAP } from "design_system/src/static/icons/map.svg";
import { Cities } from "../../../../store/reducers/cityReducer";

export interface Hub {
  title: string;
  img: any;
  map: any;
  mapM: any;
  desc: string;
  url: string;
  city: string;
}

interface Props {
  hub: Hub;
}

export const HubsItem: FC<Props> = ({ hub }) => {
  const handleMap = () => {
    window.open(hub.url, "_blank");
  };

  return (
    <div
      onClick={handleMap}
      className="dso_card m_y_lg p_x_md p_x_sm_desktop p_y_md flex_gap_sm flex_center_col_mobile flex_center_desktop flex_align_center_desktop flex_justify_start_desktop  m_x_xs bg_neutral_0 w_650_px_desktop w_250_px_mobile h_400_px_mobile h_200_px_desktop cursor_pointer"
    >
      <ScalableImage
        src={hub.img}
        alt="Sede física de Ozon ubicada en Anáhuac, CDMX"
        className="h_150_px w_100_per_mobile h_100_per_desktop"
        desktopWidth={50}
        mobileWidth={50}
      />
      <ScalableImage
        src={hub.map}
        alt="Ubicación de Ozon Anáhuac en el mapa, Laguna de Mayran 396, CDMX"
        className="h_50_px w_100_per_mobile h_100_per_desktop"
        style={{ objectFit: "cover" }}
        desktopWidth={50}
        mobileWidth={50}
      />
      <div className="dim_100_per bg_neutral_0 m_l_xs_desktop m_r_md_desktop p_y_md_desktop pos_relative p_y_md_mobile">
        <Typography scale="heading4" weight="600" className="m_none" component="h3">
          <div className="icon_text dso_centrado_v p_xxs text_primary_300">
            <MAP className="dim_lg" />
            <span className="text_primary_300"> {hub.title} </span>
          </div>
        </Typography>
        <Typography
          scale="xsmall"
          weight="400"
          className="text_neutral_900 w_200_px h_40_px m_none"
          component="p"
        >
          {hub.desc}
        </Typography>

        <Button
          scale="small"
          className=" display_none_mobile bg_neutral_700 "
          icon={<COMPANY />}
          style={{position:"absolute", bottom:"10px", right:"1px"}}
          onClick={handleMap}
        >
          {hub.city === Cities.CDMX ? "CDMX" : "GDL"}
        </Button>
        <Button
          scale="small"
          className="pos_absolute display_none_desktop bg_neutral_700 display_flex flex_align_center"
          style={{
            position:"absolute", bottom:"10px", right:"10px"
          }}
          icon={<COMPANY />}
          onClick={handleMap}
        >
          {hub.city === Cities.CDMX ? "CDMX" : "GDL"}
        </Button>
      </div>
    </div>
  );
};
